import React from "react";
import SectionMessage from "@atlaskit/section-message";
import { useCustomerMessage } from "../hooks/useCustomerMessage";

const CustomerBanner = () => {
  const { title, message, isVisible, dismiss } = useCustomerMessage();

  if (!isVisible) return null;

  return (
    <div style={{ position: "relative", marginBottom: "16px" }}>
      <SectionMessage appearance="warning" title={title || undefined}>
        {message}
      </SectionMessage>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "18px",
          lineHeight: 1,
          color: "#6b778c",
          padding: "2px 6px",
          borderRadius: "3px",
        }}
      >
        ×
      </button>
    </div>
  );
};

export default CustomerBanner;
